export default "__VITE_ASSET__DlRiNAYe__"